import type { IContextChip } from './context-chip.types'
import { ContextChipView } from './context-chip.view'

export function ContextChip(props: IContextChip) {
  return <ContextChipView {...props} />
}
